import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/login/login';
import PartnersPage from './pages/partners';
import Header from './components/header/Header';
import './assets/css/App.css';
import ClientsPage from './pages/clients';
import ClientPage from './pages/client';
import ReportPage from './pages/report';
import { roles } from './utils/define';

function ShowHeader() {
  const location = useLocation();
  return (location.pathname !== '/login' && location.pathname !== '/report') ? <Header /> : null;
}

// 認証済みか確認、未認証ならログイン画面にリダイレクト
function RequireAuth({ children }: { children: JSX.Element }) {
  const { authData } = useAuth();
  if (!authData) {
    return <Navigate to="/login" replace />;
  } 
  return children;
}

// ログイン済みの場合にリダイレクトさせるコンポーネント
function RedirectIfAuthenticated({ children }: { children: JSX.Element }) {
  const { authData } = useAuth();
  if (authData?.roles && authData.roles.includes(roles.sys_admin) && !authData?.client_id) {
    // システム管理者
    return <Navigate to="/partners" state={{ 
      admin_id: authData.admin_id,
      partnerId: authData.partner_id,
      sysStatus: authData.sysStatus
    }} replace />;
  } else if (authData?.sys_status == 0 && authData?.client_id) {
    // テレマティクス式かつ店舗の管理者の場合    
    return <Navigate to={`/partner/${authData.partner_id}/client/${authData.client_id}`} state={{
                admin_id: authData.admin_id,
                clientId: authData.client_id,
                sysStatus: authData.sysStatus
              }} replace />;
  } else if (authData?.roles) {
    // 上記以外で認証済みの場合
    return <Navigate to={`/partner/${authData.partner_id}`} state={{
                admin_id: authData.admin_id,
                roles: authData.roles,
                sysStatus: authData.sysStatus
              }} replace />;
  }

  return children;
}


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ShowHeader />
        <Routes>
          <Route path="login" element={
            <RedirectIfAuthenticated>
              <Login />
            </RedirectIfAuthenticated>
          } />
          {/* 認証が必要なページに対して RequireAuth を適用 */}
          <Route path="partners" element={<RequireAuth><PartnersPage /></RequireAuth>} />
          <Route path="partner/:partner_id" element={<RequireAuth><ClientsPage /></RequireAuth>} />
          <Route path="partner/:partner_id/client/:client_id" element={<RequireAuth><ClientPage /></RequireAuth>} />
          <Route path="report" element={<RequireAuth><ReportPage /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
